// ─── Liste de LIEUX du contact (références au carnet) ─────────────
// Plusieurs entrées { lieuId, principal } pointant vers les lieux du carnet.
// Le CHOIX passe par une fenêtre remontée à l'écran (onDemanderLieu, modale
// sœur — jamais une modale imbriquée) : déroulée dans le formulaire, la liste
// repoussait tout le reste hors de l'écran. L'une des entrées est « principale » (⭐).
import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { LigneSwipe, stylesForm, useUI, useT, confirmerSuppression } from '@mop/core';

export default function ChampsLieux({ entries = [], lieux = [], onChange, onDemanderLieu }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  const lieuDe = (id) => lieux.find(l => l.id === id);
  const dispo = lieux.filter(l => !entries.some(e => e.lieuId === l.id));
  const maj = (arr) => onChange?.(arr);
  const setPrincipal = (id) => maj(entries.map(e => ({ ...e, principal: e.lieuId === id })));
  const retirer = (id) => maj(entries.filter(e => e.lieuId !== id));
  const ajouter = (l) => maj([...entries, { lieuId: l.id, principal: entries.length === 0 }]);
  const demander = () => onDemanderLieu?.({ dispo, onChoisir: ajouter });

  return (
    <View style={{ marginTop: 4 }}>
      <Text style={s.lbl}>{t('contacts.lieux')}</Text>
      {entries.map(e => {
        const l = lieuDe(e.lieuId);
        return (
          <LigneSwipe key={e.lieuId} espacement={8} onSupprimer={() => retirer(e.lieuId)}>
            {/* Appui long : SEUL recours sur le web, ou le swipe n'est pas fiable. */}
            <TouchableOpacity activeOpacity={1} style={[s.bloc, { marginTop: 0 }]}
              onLongPress={() => confirmerSuppression(t('commun.supprimer'), l?.nom || '', () => retirer(e.lieuId))}>
              <TouchableOpacity onPress={() => setPrincipal(e.lieuId)} hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}>
                <Text style={{ fontSize: 20, opacity: e.principal ? 1 : 0.45 }}>{e.principal ? '⭐' : '☆'}</Text>
              </TouchableOpacity>
              <View style={{ flex: 1, minWidth: 0 }}>
                <Text style={s.nom} numberOfLines={1}>📍 {l?.nom || t('lieux.aucun')}</Text>
                {!!l?.adresse && <Text style={s.sous} numberOfLines={1}>{l.adresse}</Text>}
              </View>
            </TouchableOpacity>
          </LigneSwipe>
        );
      })}
      <TouchableOpacity style={s.ajouter} activeOpacity={0.7} onPress={demander}>
        <Text style={{ color: UI.accent, fontWeight: '700' }}>＋ {t('contacts.ajouterLieu')}</Text>
      </TouchableOpacity>
    </View>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  ...stylesForm(UI),
  bloc: { flexDirection: 'row', alignItems: 'center', gap: 10, marginTop: 8, padding: 11, backgroundColor: UI.card, borderRadius: 12, borderWidth: 0.5, borderColor: UI.border },
  nom: { fontSize: 14.5, fontWeight: '700', color: UI.ink },
  sous: { fontSize: 12, color: UI.faint, marginTop: 1 },
  liste: { marginTop: 8, backgroundColor: UI.card, borderRadius: 12, borderWidth: 0.5, borderColor: UI.border, overflow: 'hidden' },
  opt: { flexDirection: 'row', alignItems: 'center', gap: 10, paddingVertical: 11, paddingHorizontal: 12, borderBottomWidth: 0.5, borderBottomColor: UI.border },
  optNom: { fontSize: 14, color: UI.ink },
  vide: { fontSize: 13, color: UI.faint, lineHeight: 18, padding: 12 },
  ajouter: { paddingVertical: 9, alignItems: 'center', marginTop: 4 },
});
